import {Module} from "../common/Module";
import {isPrivileged} from "../../config/Privileges";
import {systemAreaName} from "../user-groups/UserGroup";

/**
 * Represents a module for managing user API keys within the system.
 *
 * This module provides functionality for interacting with user API keys,
 * including checking access permissions based on the user's roles and system privileges.
 */
export const UserApiKeyModule: Module = {
    identifier: "api_keys",
    isPrivileged: ( authUser, privilege) => isPrivileged(
        authUser,
        systemAreaName,
        UserApiKeyModule.identifier,
        privilege
    )
};